<template>
  <v-card class='text-center'>
    <v-card-text>
      <ValidationObserver ref='observer' v-slot='{ passes  }'>
        <v-form>
          <v-container>
            <v-row>
              <v-col  lg="12" md="12" cols="12">
                <v-row justify="center" >
                  <v-col cols="4">
                    <ValidationProvider rules="required" v-slot="{ errors }" name="logo">
                      <image-input v-model="avatar">
                        <div slot="activator">
                          <v-avatar size="100" v-ripple v-if="!avatar"
                                    class="grey lighten-3 mb-3">
                            <span>Adicionar Avatar</span>
                          </v-avatar>
                          <v-avatar size="100" @click="saved =  false" v-ripple v-else
                                    class="mb-3">
                            <img :src="avatar.imageURL" alt="avatar">
                          </v-avatar>
                        </div>
                      </image-input>
                      <v-slide-x-transition>
                        <div v-if="avatar && saved == false">
                          <v-btn class="primary" @click="uploadImage" :loading="saving">
                            Salvar Avatar
                          </v-btn>
                        </div>
                      </v-slide-x-transition>
                      <span style="color: #ff5252">{{ errors[0]}}</span>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
               cols='12'
               md='6'
              >
                <ValidationProvider rules='required|min:3' name='Nome' v-slot='{ errors }'>
                  <v-text-field
                   v-model='manager.name'
                   :error-messages='errors'
                   label='Nome'
                   prepend-inner-icon='mdi-account-outline'
                   ref='initialFocus'
                   outlined
                   dense
                   required
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <v-col
               cols='12'
               md='6'
              >
                <ValidationProvider rules='required|email' name='email' v-slot='{ errors }'>
                  <v-text-field
                   dense
                   v-model='manager.email'
                   :error-messages='errors'
                   label='E-mail'
                   prepend-inner-icon='mdi-email-outline'
                   outlined
                   required

                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col
               cols='12'
               md='6'
              >
                <ValidationProvider rules='required|min:3' name='shortname' v-slot='{ errors }'>
                  <v-text-field
                   :error-messages='errors'
                   label='Nome Usuario'
                   prepend-inner-icon='mdi-account-check-outline'
                   v-model="manager.shortname"
                   outlined
                   dense
                   required
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <v-col
               cols='12'
               md='6'
              >
                <ValidationProvider rules='required' name='photo' v-slot='{ errors }'>
                  <v-text-field
                   dense
                   v-model='manager.phone'
                   :error-messages='errors'
                   label='Contato'
                   prepend-inner-icon='mdi-phone-outline'
                   v-mask="['(##) ####-####', '(##) #####-####']"
                   outlined
                   required
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col
               cols='12'
               md='6'
              >
                <ValidationProvider rules='required|min:3' name='Perfil' v-slot='{ errors }'>
                  <v-text-field
                   v-model='role'
                   :error-messages='errors'
                   label='Perfil'
                   prepend-inner-icon='mdi-account-check-outline'
                   outlined
                   dense
                   readonly
                   required
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <v-col
               cols='12'
               md='6'
              >
                <ValidationProvider rules='required' name='client' v-slot='{ errors }'>
                  <v-text-field
                   :error-messages='errors'
                   label='Clientes'
                   v-model="client.name"
                   outlined
                   dense
                   readonly
                   required
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row class="text-right">
              <v-col
               cols='12'
               md='12'
              >
                <v-btn  :to="areaRoute" outlined class="mr-10"  color="primary">
                  Cancelar
                </v-btn>
                <v-btn black v-if="operation=='create'" class="mr-10" @click="passes(createSubmit)" color="primary">
                  Salvar
                </v-btn>
                <v-btn black v-else class="mr-10" @click="passes(updateSubmit)" color="primary">Atualizar</v-btn>
                <v-btn black outlined @click="clear" color="primary">Limpar</v-btn>
              </v-col>
            </v-row>
          </v-container>

        </v-form>
      </ValidationObserver>
    </v-card-text>

  </v-card>
</template>

<script>

 import {ValidationObserver, ValidationProvider} from 'vee-validate'
 import {CreateMutation, UpdateMutation} from '@/graphql/mutations/Manager.gql'
 import {getManager} from '@/graphql/queries/Manager.gql'
 import {UploadFile} from '@/graphql/mutations/UploadImage.gql'
 import {apolloClient} from '@/vue-apollo'
 import areaRouteMixin from '@/mixins/area-route'
 import hashCodeMixin from '@/mixins/hash-code'
 import {mask} from 'vue-the-mask'
 import ImageInput from '@/components/appComponents/ImageInput'
 import mixinsForm from '../../../mixins/notification-form'

 export default {
  components: {
   ValidationObserver,
   ValidationProvider,
   ImageInput
  },
  mixins: [
   areaRouteMixin,
   hashCodeMixin,
    mixinsForm
  ],
  directives: {
   mask
  },
  data() {
   return {
    accessedArea: 'managers',
    avatar: null,
    avatarBase: null,
    saving: false,
    id_update: null,
    saved: false,
    manager: {}
   }
  },
  apollo: {
   roles: {
    query: require('@/graphql/queries/Role.gql').getManagersRole,
    update: data => data.managersRole
   }
  },
  computed: {

   operation() {
    if (!this.$route.params.id) {
     return 'create'
    } else {
     return 'update'
    }
   },
   role: {
    get() {
     return this.roles ? this.roles.name : ''
    },
    set(val) {
     return val
    }
   },
   client: {
    get() {
     return this.$store.state.defaultClient ? this.$store.state.defaultClient : ''
    },
    set(val) {
     return val
    }
   },
   dataSubmit() {
    const data = {
     name: this.manager.name,
     email: this.manager.email,
     shortname: this.manager.shortname,
     phone: this.manager.phone,
     avatar:this.manager.avatar
    }
    return data
   }
  },
  methods: {
   uploadImage() {
    if(this.id_update){
     if (this.avatar.imageURL !=  this.manager.avatar) {
      this.$apollo.mutate({
       mutation: UploadFile,
       variables: {
        file: this.avatar.imageFile
       }
      }).then((data) => {
       this.manager.avatar = data.data.upload
       this.$toasted.global.defaultSuccess();
      }).catch((error) => {
       console.error(error)
       this.$toasted.global.defaultError(error);
      });
     }
     setTimeout(() => this.savedAvatar(), 1000)
    }else{
     this.$apollo.mutate({
      mutation: UploadFile,
      variables: {
       file: this.avatar.imageFile
      }
     }).then((data) => {
      this.manager.avatar = data.data.upload
      this.$toasted.global.defaultSuccess();
     }).catch((error) => {
      console.error(error)
      this.$toasted.global.defaultError(error);
     });
     setTimeout(() => this.savedAvatar(), 1000)
    }
   },
   savedAvatar() {
    this.saving = false
    this.saved = true
   },
   clear() {
    this.manager = {}
   },
   createSubmit() {
    this.$apollo.mutate({
     mutation: CreateMutation,
     variables: {
      ...this.dataSubmit,
      roles: this.roles.id
     }
    }).then(() => {
     this.showCreateMessage()
     this.$router.push(this.areaRoute)
    }).catch((e)=>{
     console.error(e)
     this.showErrorMessage(e)
    });
   },
   updateSubmit() {
    const dataUp = this.dataSubmit
    if (this.avatar.imageURL ===  this.manager.avatar) {
     delete dataUp.avatar
    }
    this.$apollo.mutate({
     mutation: UpdateMutation,
     variables: {
      id: this.$route.params.id,
      ...this.dataSubmit,
     }
    }).then(() => {
     this.showUpdateMessage()
     this.$router.push(this.areaRoute)
    }).catch(this.showErrorMessage);
   }
  },
  beforeRouteEnter(to, from, next) {
   if (to.params.id) {
    apolloClient.query({
     query: getManager,
     variables: {
      id: to.params.id
     }
    }).then(({data: {manager}}) => {
     if (manager) {
      next(vm => {
       vm.avatar = {
        imageURL: manager.avatar
       }
       vm.manager.avatar = manager.avatar
       vm.avatarBase = manager.avatar
       vm.id_update = manager.id
       vm.manager.name = manager.name
       vm.manager.email = manager.email
       vm.manager.shortname = manager.shortname
       vm.manager.phone = manager.phone
       vm.client = manager.client.id
       vm.role = manager.roles.map((e) => {
        return e.id
       })
      })
     }
    }).catch((error) => {
     console.error('Erro na Consulta', JSON.stringify(error.message))
    })
   } else {
    next()
   }
  },
  mounted() {
   this.setOnFocus('initialFocus')
  }
 }

</script>